import gql from "graphql-tag";

export default gql`
  mutation DeletePart($id: ID!) {
    deletePart(id: $id) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/DeletePart.ts